<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="description.objet"

[label]="step2.getobjet"
[type]="'text'" [rule]="'required|minSize_5'"
[errorMessage]="{'required' : 'ctr_107', 'minLength' : 'ctr_123'}"
[name]="getUid()+'_SepAtt_objet'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"

[label]="step2.gettravaux"
[type]="'checkbox'" [rule]="'pattern_29'"
[checkboxDestination]="'string'"
[isChecked]="natureMarche.travaux"
[name]="getUidNatureMarche()+'_SepAtt_travaux'">
</app-form-input>

<app-type-travaux *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [marcheTravaux]="description.marcheTravaux"></app-type-travaux>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"

[label]="step2.getfournitures"
[type]="'checkbox'" [rule]="'pattern_29'"
[checkboxDestination]="'string'"
[isChecked]="natureMarche.fournitures"
[name]="getUidNatureMarche()+'_SepAtt_fournitures'">
</app-form-input>

<app-type-fournitures *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [marcheFournitures]="description.marcheFournitures"></app-type-fournitures>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"

[label]="step2.getservices"
[type]="'checkbox'" [rule]="'pattern_29'"
[checkboxDestination]="'string'"
[isChecked]="natureMarche.services"
[name]="getUidNatureMarche()+'_SepAtt_services'">
</app-form-input>

<app-form-input *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"

[value]="description.marcheServices"

[label]="step2.getmarcheservices"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_marcheServices'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="description.isLieuExecutionLivraison"
[label]="step2.getlieuexecutionlivraison"
[checkboxDestination]="'boolean'"
[type]="'checkbox'" [rule]="''"
[name]="getUid()+'_SepAtt_lieuExecutionCB'">
</app-form-input>

<span [id]="getUid()+'_SepAtt_lieuExecution'" hidden= "" class="span d-block" *ngIf="!estCbChecked">{{ step2.getspan1  | translate }}</span>

<app-type-lieu *ngIf="!estCbChecked" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_176', 'pattern' : 'ctr_221'}"
 [lieuExecutionLivraison]="description.lieuExecution"></app-type-lieu>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg5" [id]="getStepId() + rg5"></app-form-input-error>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg6" [id]="getStepId() + rg6"></app-form-input-error>
<span [id]="getUid()+'_SepAtt_lieuLivraison'" hidden= "" class="span d-block">{{ step2.getspan2  | translate }}</span>

<app-type-lieu *ngIf="!estCbChecked"  [uid]="'lieuLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_175', 'pattern' : 'ctr_222'}"
 [lieuExecutionLivraison]="description.lieuLivraison"></app-type-lieu>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg7" [id]="getStepId() + rg7"></app-form-input-error>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg8" [id]="getStepId() + rg8"></app-form-input-error>

<app-type-lieu *ngIf="estCbChecked" [uid]="'lieuExecutionLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_176', 'pattern' : 'ctr_43'}"
 [lieuExecutionLivraison]="description.lieuExecutionLivraison"></app-type-lieu>
 <app-form-input-error *ngIf="estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>
 <app-form-input-error *ngIf="estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg9" [id]="getStepId() + rg9"></app-form-input-error>
 <app-form-input-error *ngIf="estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg10" [id]="getStepId() + rg10"></app-form-input-error>


 <app-type-objCPV  *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [cPV]="description.cpv"></app-type-objCPV>


